import React from 'react';
import { Redirect } from 'expo-router';

// REQUEST/chat de negociação de recorrência desativado no front por ora.
// Tela original preservada abaixo para reativar depois.
export default function ProviderChatListScreen() {
  return <Redirect href="/(tabs)/(provider)/schedule" />;
}

/*
import { router } from 'expo-router';
import { ConversationList } from '@/components/schedule/conversation-list';

export default function ProviderChatListScreen() {
  return (
    <ConversationList
      title="Negociações"
      viewer="provider"
      onBack={() => router.back()}
      onOpen={c => router.push(`/(tabs)/(provider)/schedule/chat/${c.id}`)}
    />
  );
}
*/
